import * as React from "react";
import { SiteContext } from "../../../site-context/site-context";
import { Table, TBody } from "../../ui-library/table/table";
import TextSkeleton from "../../ui-library/text/text-skeleton";
import CoinTickersTableHead from "./coin-tickers-table-head";
import styles from "./coin-tickers-table.styles";

const CoinTickersTableSkeleton: React.FC = () => {
  const { isMobile } = React.useContext(SiteContext);

  const rows = new Array(15).fill(0).map((_, i) => i);

  return (
    <div css={styles.root}>
      <Table>
        <CoinTickersTableHead />
        <TBody>
          {rows.map((row) => (
            <tr key={row}>
              {!isMobile && (
                <td css={[styles.colAlignment[0], styles.rank]}></td>
              )}
              <td css={[styles.colAlignment[1]]}>
                <TextSkeleton width={140} />
              </td>
              <td css={[styles.colAlignment[2], styles.ticker]}>
                <TextSkeleton width={80} />
              </td>
              <td css={[styles.colAlignment[3], styles.label]}>
                <TextSkeleton width={60} textAlign="right" />
              </td>
              <td css={[styles.colAlignment[4], styles.label]}>
                <TextSkeleton width={80} textAlign="right" />
              </td>
              <td css={[styles.colAlignment[5], styles.label]}>
                <TextSkeleton width={40} textAlign="right" />
              </td>
            </tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

export default CoinTickersTableSkeleton;
